module.exports = __webpack_public_path__ + "static/logo_edreams-c09be5096d000eca46bfd246441a821e.png";